import React = require("react");

interface InfoViewProps extends React.Props<InfoView> {
    title?: string;
    style?: React.CSSProperties;
}

export default class InfoView extends React.Component<InfoViewProps, {}> {

    render() {
        return (
            <div className="dialog-body info" style={this.props.style}>
                {this.props.title
                    ? <h3 className="dialog-title">{this.props.title}</h3>
                    : ""}

                <div className="dialog-description">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/info-dialog/views/InfoView.tsx
 **/